import { UniqueIdentifier } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { useMemo } from 'react'

import { DragContext, DragContextProps } from './DragContext'

type Props = {
  id: UniqueIdentifier
  disabled?: boolean
  styleOverlay?: boolean
  children?: (values: DragContextProps) => React.ReactNode
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'id' | 'children'>

export const ZoneItem = ({
  id,
  disabled,
  styleOverlay,
  children,
  ...props
}: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    isDragging,
    isOver
  } = useSortable({ id, disabled })

  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    ...(isDragging && { position: 'relative', zIndex: 1000 }),
    ...(isOver && styleOverlay && { opacity: 0.6 })
  }

  const contextValue = useMemo(
    () => ({ setActivatorNodeRef, listeners }),
    [setActivatorNodeRef, listeners]
  )

  return (
    <DragContext.Provider value={contextValue}>
      <div {...props} ref={setNodeRef} style={style} {...attributes}>
        {children?.(contextValue)}
      </div>
    </DragContext.Provider>
  )
}
